var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileBackButtonIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 24 0)",
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.12508L11.12 12.0051L15 15.8851C15.39 16.2751 15.39 16.9051 15 17.2951C14.61 17.6851 13.98 17.6851 13.59 17.2951L8.99998 12.7051C8.60998 12.3151 8.60998 11.6851 8.99998 11.2951L13.59 6.70508C13.7768 6.51783 14.0305 6.4126 14.295 6.4126C14.5595 6.4126 14.8131 6.51783 15 6.70508C15.38 7.09508 15.39 7.73508 15 8.12508Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBackButtonIconLight);
export default __webpack_public_path__ + "static/media/mobile-back-button-icon-light.9b5dc1be.svg";
export { ForwardRef as ReactComponent };